// MainLayout.js
import { useLocation } from "react-router-dom";
import Footer from "../constants/footer";
import Header from "../constants/header";

const MainLayout = ({ children }) => {
  const location = useLocation();

  // Routes where header/footer should be hidden
  const hideHeaderFooter = ["/new-client-form", "/links"];

  const shouldHide = hideHeaderFooter.includes(location.pathname);

  return (
    <>
      {!shouldHide && <Header />}
      <main>{children}</main>
      {!shouldHide && <Footer />}
    </>
  );
};

export default MainLayout;
